module.exports = __webpack_public_path__ + "img/shanghaisxy.36deeeac.jpg";